import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useToast } from '@chakra-ui/react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Text,
  Flex,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';

import * as FiIcons from 'react-icons/fi';

import { addBalance } from '../../../../../store/wallet/walletSlice';

import theme from '../../../../global/theme';

const AddBalanceModal = ({ data, onClose }) => {
  const dispatch = useDispatch();
  const toast = useToast({ position: 'top', duration: 3000 });
  const wallet = useSelector(state => state.wallet);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius={20} padding={4} bg={theme.dark}>
        <form onSubmit={handleSubmit(values => {
          dispatch(addBalance({ userId: data._id, amount: Number(values.amount), note: values.note }))
            .unwrap()
            .then(() => {
              toast({ description: `تم إضافة الرصيد لحساب ${data.name}`, status: 'success' });
              onClose();
            });
        })}>
          <ModalHeader textAlign="center" color="orange" textTransform="uppercase" fontSize={22}>
            إضافة رصيد
          </ModalHeader>
          <ModalBody>
            {wallet.adminTransactions.errors.length > 0 && (
              <Alert status="error" variant="left-accent" marginBottom={4}>
                <AlertIcon />
                {wallet.adminTransactions.errors.map((error, index) => (
                  <Text key={index}>{error?.msg}</Text>
                ))}
              </Alert>
            )}

            <Text color="white" marginBottom={4}>
              إضافة رصيد إلى حساب <strong>{data.name}</strong> ({data.email})
            </Text>

            <FormControl marginBottom={4}>
              <FormLabel fontWeight="bold" color="white">المبلغ (دولار)</FormLabel>
              <Input
                type="number" step="0.01" min="0.01" bg={theme.bg} color={theme.dark} border="none" borderRadius={4}
                placeholder="أدخل المبلغ"
                {...register('amount', {
                  required: 'هذا الحقل مطلوب',
                  min: { value: 0.01, message: 'يرجى إدخال مبلغ صحيح' },
                })}
              />
              {errors.amount?.message && <Text color="red.600" marginTop={2}>{errors.amount.message}</Text>}
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="white">ملاحظة (اختياري)</FormLabel>
              <Textarea
                bg={theme.bg} color={theme.dark} border="none" borderRadius={4}
                placeholder="سبب إضافة الرصيد"
                {...register('note')}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Flex justifyContent="flex-end">
              <Button
                type="submit"
                rightIcon={<FiIcons.FiSave />}
                color="white" bg="green" paddingInline={4}
                paddingBlock={2} height="auto" textTransform="capitalize"
                isLoading={wallet.adminTransactions.isLoading}
                _hover={{ background: 'green' }}
              >
                حفظ
              </Button>
              <Button
                type="button"
                onClick={onClose}
                rightIcon={<FiIcons.FiMinimize2 />}
                color="white" bg="red.600" paddingInline={4}
                paddingBlock={2} height="auto" textTransform="capitalize"
                marginInlineStart={4}
                isLoading={wallet.adminTransactions.isLoading}
                _hover={{ background: 'red.600' }}
              >
                إغلاق
              </Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default AddBalanceModal;
